import React, {useContext, useEffect, useState} from "react";
/// React router dom
import {Routes, Route, Outlet, useLocation, Link} from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import {ThemeContext} from "../context/ThemeContext";
/// Dashboard
import Home from "./components/Dashboard/Home";
import Analytics from "./components/Dashboard/Analytics";
import Customers from "./components/Dashboard/Customers";
import Event from "./components/Dashboard/Event";
import EventDetail from "./components/Dashboard/EventDetail";
import Reviews from "./components/Dashboard/Reviews";
import Task from "./components/Dashboard/Task";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import EcomCustomers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import RechartJs from "./components/charts/rechart";
import ChartJs from "./components/charts/Chartjs";
//import Chartist from './components/charts/chartist'
import SparklineChart from "./components/charts/Sparkline";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
//import Nestable from './components/PluginsMenu/Nestable/Nestable'
//import MainNouiSlider from './components/PluginsMenu/Noui Slider/MainNouiSlider'
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

/// Widget
import Widget from "./pages/Widget";

/// Table
import DataTable from "./components/table/DataTable";
import BootstrapTable from "./components/table/BootstrapTable";
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";

/// Form
//import ReduxForm from "./components/Forms/ReduxForm/ReduxForm";
//import WizardForm from "./components/Forms/ReduxWizard/Index";
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Todo from "./pages/Todo";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
import TelVerification from "./components/shared/telVerification";
import ListOfferPage from "./pages/offer";
import OfferPage from "./pages/offer/offerPage";
import ChatPage from "./pages/messages/ChatPage";
import {components} from "react-select";
import ListFavoriteOfferPage from "./pages/offer/favorites";
import ProfileTechPage from "./pages/ProfileAnonyme/profileTech";
import ListMesOfferPage from "./pages/offer/mesOffres";
import ListInterventionPage from "./pages/intervention";
import PageMesInterventionsClient from "./pages/intervention/pageMesInterventionClient";
import InterventionPage from "./pages/intervention/interventionPage";
import FactureListPageClient from "./pages/factures/facturesClient";
import {
  useNotification,
  useNotificationPermission,
} from "../hooks/useNotification";
import {useDispatch, useSelector} from "react-redux";
import ProfileClientPage from "./pages/ProfileAnonyme/profileClient";
import {Alert, Button} from "react-bootstrap";
import HelpClicChatbot from "./components/shared/HelpClicChatbot";
import DashboardPage from "./pages/dashboard/dashboardPage";
import {usePubsQuery} from "../hooks/usePubs";
import {use} from "react";
import FactureListPageTech from "./pages/factures/facturesTech";
import {useQuery} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useMe} from "../hooks/useGetUser";
import {bancApi} from "../services/technicianService";
import {userRoleList} from "../utils/constants";
import {getProfileCompletion} from "../utils/profileCompletion";

const profileFieldTranslationKeys = {
  address: "profileFieldAddress",
  bio: "profileFieldBio",
  interventionAreas: "profileFieldInterventionAreas",
  sectors: "profileFieldSectors",
  bankAccount: "profileFieldBankAccount",
  stripeValidation: "profileFieldStripeValidation",
  paymentFrequency: "profileFieldPaymentFrequency",
  emailVerification: "profileFieldEmailVerification",
};

export const clientAllroutes = [
  {url: "", component: <ListMesOfferPage />},
  {url: "annonce", component: <ListOfferPage />},
  {url: "favoris", component: <ListFavoriteOfferPage />},
  {url: "annonce/:id", component: <OfferPage />},
  {url: "messages", component: <ChatPage />},
  {url: "prestataire/:id", component: <ProfileTechPage />},
  {url: "interventions", component: <PageMesInterventionsClient />},
  {url: "intervention/:id", component: <InterventionPage />},
  {url: "factures", component: <FactureListPageClient />},
];

export const Techallroutes = [
  /// Dashboard
  {url: "", component: <ListOfferPage />},
  {url: "annonce", component: <ListOfferPage />},
  {url: "favoris", component: <ListFavoriteOfferPage />},
  {url: "annonce/:id", component: <OfferPage />},
  {url: "messages", component: <ChatPage />},
  {url: "interventions", component: <ListInterventionPage />},
  {url: "prestataire/:id", component: <ProfileTechPage />},
  {url: "client/:id", component: <ProfileClientPage />},
  {url: "intervention/:id", component: <InterventionPage />},
  {url: "factures", component: <FactureListPageTech />},

  {url: "tableau-de-bord", component: <DashboardPage />},
  // {url: "dashboard", component: <Home />},
  {url: "event", component: <Event />},
  {url: "event-detail", component: <EventDetail />},
  {url: "customers", component: <Customers />},
  {url: "analytics", component: <Analytics />},
  {url: "reviews", component: <Reviews />},
  {url: "task", component: <Task />},

  /// Apps
  {url: "profil", component: <AppProfile />},
  {url: "post-details", component: <PostDetails />},
  {url: "email-compose", component: <Compose />},
  {url: "email-inbox", component: <Inbox />},
  {url: "email-read", component: <Read />},
  {url: "app-calender", component: <Calendar />},

  /// Chart
  {url: "chart-sparkline", component: <SparklineChart />},
  {url: "chart-chartjs", component: <ChartJs />},
  //{ url: 'chart-chartist', component: Chartist },
  {url: "chart-apexchart", component: <ApexChart />},
  {url: "chart-rechart", component: <RechartJs />},

  /// Bootstrap
  {url: "ui-alert", component: <UiAlert />},
  {url: "ui-badge", component: <UiBadge />},
  {url: "ui-button", component: <UiButton />},
  {url: "ui-modal", component: <UiModal />},
  {url: "ui-button-group", component: <UiButtonGroup />},
  {url: "ui-accordion", component: <UiAccordion />},
  {url: "ui-list-group", component: <UiListGroup />},
  {url: "ui-card", component: <UiCards />},
  {url: "ui-carousel", component: <UiCarousel />},
  {url: "ui-dropdown", component: <UiDropDown />},
  {url: "ui-popover", component: <UiPopOver />},
  {url: "ui-progressbar", component: <UiProgressBar />},
  {url: "ui-tab", component: <UiTab />},
  {url: "ui-pagination", component: <UiPagination />},
  {url: "ui-typography", component: <UiTypography />},
  {url: "ui-grid", component: <UiGrid />},

  /// Plugin
  {url: "uc-select2", component: <Select2 />},
  //{ url: 'uc-nestable', component: Nestable },
  //{ url: 'uc-noui-slider', component: MainNouiSlider },
  {url: "uc-sweetalert", component: <MainSweetAlert />},
  {url: "uc-toastr", component: <Toastr />},
  {url: "map-jqvmap", component: <JqvMap />},
  {url: "uc-lightgallery", component: <Lightgallery />},

  /// Widget
  {url: "widget-basic", component: <Widget />},

  /// Shop
  {url: "ecom-product-grid", component: <ProductGrid />},
  {url: "ecom-product-list", component: <ProductList />},
  {url: "ecom-product-detail", component: <ProductDetail />},
  {url: "ecom-product-order", component: <ProductOrder />},
  {url: "ecom-checkout", component: <Checkout />},
  {url: "ecom-invoice", component: <Invoice />},
  {url: "ecom-product-detail", component: <ProductDetail />},
  {url: "ecom-customers", component: <EcomCustomers />},

  /// Form

  //{ url: 'form-redux', component: ReduxForm },
  //{ url: 'form-redux-wizard', component: WizardForm },
  {url: "form-element", component: <Element />},
  {url: "form-wizard", component: <Wizard />},
  {url: "form-pickers", component: <Pickers />},
  {url: "form-validation", component: <FormValidation />},

  /// table
  {url: "table-datatable-basic", component: <DataTable />},
  {url: "table-bootstrap-basic", component: <BootstrapTable />},
  {url: "table-filtering", component: <FilteringTable />},
  {url: "table-sorting", component: <SortingTable />},

  /// pages
  /* {url: "page-register", component: <Registration />},
  {url: "page-lock-screen", component: <LockScreen />},
  {url: "page-tel", component: <TelVerification />},
  {url: "page-login", component: <Login />}, */
  {url: "todo", component: <Todo />},
];

// const Markup = () => {
//   // let path = window.location.pathname
//   // path = path.split('/')
//   // path = path[path.length - 1]
//   // let pagePath = path.split('-').includes('page')
//   // const [activeEvent, setActiveEvent] = useState(!path)

//   return (
//     <>
//       <Route path="page-lock-screen" element={<LockScreen />} />
//       <Route path="erreur-400" element={<Error400 />} />
//       <Route path="erreur-403" element={<Error403 />} />
//       <Route path="erreur-404" element={<Error404 />} />
//       <Route path="erreur-500" element={<Error500 />} />
//       <Route path="erreur-503" element={<Error503 />} />
//       <Route element={<MainLayout />}>
//         {allroutes.map((data, i) => (
//           <Route key={i} exact path={`${data.url}`} element={data.component} />
//         ))}
//       </Route>
//     </>
//   );
// };

export function MainLayout({user}) {
  const location = useLocation();
  const {t} = useTranslation();
  const {id: userId} = useSelector((state) => state.auth.auth);
  const {data: freshUser} = useMe();
  const currentUser = freshUser ?? user;
  const isTechnician =
    currentUser?.selectedRole === userRoleList.TECHNICIAN;
  const hasBankAccount = Boolean(
    currentUser?.Technician?.BankAccounts?.length,
  );
  const {
    data: stripeStatus,
    isFetched: stripeStatusFetched,
  } = useQuery({
    queryKey: ["stripeConnectStatus", currentUser?.id],
    queryFn: bancApi.getConnectStatus,
    enabled: isTechnician && hasBankAccount,
    refetchOnWindowFocus: false,
    refetchInterval: (query) =>
      isTechnician && hasBankAccount && !query.state.data?.ready
        ? 5 * 60_000
        : false,
    staleTime: 5 * 60_000,
  });
  const profileCompletion = getProfileCompletion(currentUser, {
    stripeStatus,
    stripeStatusLoaded: !hasBankAccount || stripeStatusFetched,
  });
  const {data, isLoading, isError} = usePubsQuery();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!isLoading && !isError && data?.length > 0) {
      dispatch({
        type: "LIST_PUB",
        payload: data,
      });
    }
  }, [data, isLoading, isError]);
  const [showAlert, setShowAlert] = useState(true);
  const warningFingerprint = `${currentUser?.id ?? ""}:${profileCompletion.missingFields.join("|")}`;
  useEffect(() => {
    setShowAlert(true);
  }, [warningFingerprint]);

  const profileWarningMessage = t("profileIncompleteDescription", {
    items: profileCompletion.missingFields
      .map((field) => t(profileFieldTranslationKeys[field]))
      .join(", "),
  });
  const firstMissingField = profileCompletion.missingFields[0];
  const profileCompletionLink = [
    "bankAccount",
    "stripeValidation",
    "paymentFrequency",
  ].includes(firstMissingField)
    ? "/paiement"
    : ["interventionAreas", "sectors"].includes(firstMissingField)
      ? "/mon-profil"
      : "/mon-compte";
  useNotificationPermission({userId});

  const {notificationList} = useNotification();
  return (
    <div
      id="main-wrapper"
      className={`show !overflow-visible ${
        location.pathname.includes("messages") ? "" : ""
      }`}
    >
      <Nav notificationList={notificationList} />

      <div
        className={`   ${
          location.pathname.includes("messages") /* ||
          location.pathname.includes("centre-aide") */
            ? "w-full mx-0 !min-h-[calc(100dvh-70px)] h-[calc(100dvh-70px)] sm:!min-h-[calc(100vh-70px)] sm:h-[calc(100dvh-70px)] mt-[70px] "
            : "lg:max-w-[73%] lg:min-w-[1010px] mx-auto !pb-4 mt-[94px] !h-[calc(100dvh-94px)] !min-h-[calc(100dvh-94px)] "
        } ${location.pathname.includes("centre-aide") ? "!mt-[70px]" : ""} `}
        // style={{minHeight: window.screen.height - 70}}
      >
        <div className="container-fluid p-0 h-full  ">
          {profileCompletion.isReady &&
            !profileCompletion.isComplete &&
            showAlert &&
            !location.pathname.includes("verification") &&
            !location.pathname.includes("verifier") && (
              <Alert
                variant={"warning"}
                className="alert-dismissible fade show flex gap-2 items-center mx-6 lg:mx-0 justify-between !rounded-lg"
              >
                <div className="flex items-center gap-2 text-sm leading-4">
                  <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className=""
                  >
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  </svg>
                  <span>
                    <strong>{t("profileIncompleteTitle")}.</strong>{" "}
                    {profileWarningMessage}
                  </span>
                </div>
                <Link
                  to={profileCompletionLink}
                  className="sm:underline font-medium text-sm flex items-center text-[#ff6d4d] hover:text-blue-600 "
                >
                  <span className="hidden sm:block">
                    {t("profileIncompleteLink")}
                  </span>
                  <i className="fi fi-rr-arrow-up-right items-center flex sm:hidden"></i>
                </Link>
                <Button
                variant=""
                className="close h-100 !p-0 !ml-1"
                aria-label="Close"
                onClick={() => setShowAlert(false)}
              >
                <span>
                  <i className="mdi mdi-close"></i>
                </span>
              </Button>
              </Alert>
            )}

          <Outlet />
        </div>
      </div>
      {!location.pathname.includes("messages") && <HelpClicChatbot />}
      {/* <Footer /> */}
    </div>
  );
}

// export default Markup;
